<script lang="ts" setup>
import { computed } from 'vue'
import { RouteLocationRaw, useRoute } from 'vue-router'

import RhsSummary from '@/stay-displayer/smr/rhs/RhsSummary.vue'
import { CursorHelper, getWeekNbText } from '@/stay-displayer/smr/utils'
import { useStore } from '@/store'
import { Rhs, SmrStay } from '@/store/modules/stay/smr/types'
const store = useStore()
const route = useRoute()

const props = defineProps<{
  stay: SmrStay
}>()

const rhsNavigator = new CursorHelper<Rhs>(props.stay.rhsList, 4)
const mode = computed(() => store.state.settings.pmsi.mode)

function getRhsDisplayerRoute(rhsId: number) {
  const targetIndex = props.stay.rhsList.findIndex((rhs) => rhs.id === rhsId)
  const displayerRoute: RouteLocationRaw = {
    name: 'rhs',
    params: {
      stayId: props.stay.id,
      rhsId
    },
    query: {
      ...route.query,
      rhsNumber: targetIndex + 1,
    }
  }

  return displayerRoute
}
</script>

<template>
  <div class="row">
    <div class="col-auto p-0 pt-5">
      <span
        class="display-5"
        :class="{cp: rhsNavigator.canMoveDown.value}"
        :style="{opacity: !rhsNavigator.canMove.value ? 0 : (rhsNavigator.canMoveDown.value ? 1 : 0.3)}"
        @click.prevent="rhsNavigator.moveCursor(-1)"
      >&#8592;</span>
    </div>
    <div class="col">
      <div class="row">
        <div
          v-for="(rhs, idx) in rhsNavigator.displayedElements.value"
          :key="rhs.id"
          class="col-3"
        >
          <div class="nav-header mb-2 text-center">
            <router-link
              :id="'week-link-'+idx"
              :to="getRhsDisplayerRoute(rhs.id)"
            >
              <span v-tooltip="rhs.startDate.format('DD/MM/YYYY')">{{ getWeekNbText(rhs, true) }}</span>
            </router-link>
          </div>
          <div class="border">
            <rhs-summary
              :rhs="rhs"
              :hospitalization-type="stay.hospitalizationType"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="col-auto p-0 pt-5">
      <span
        :style="{opacity: !rhsNavigator.canMove.value ? 0 : (rhsNavigator.canMoveUp.value ? 1 : 0.3)}"
        class="display-5"
        :class="{cp: rhsNavigator.canMoveUp.value}"
        @click.prevent="rhsNavigator.moveCursor(1)"
      >&#8594;</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.display-5 {
  user-select: none;
}

.border {
  border-radius: 7px;
}
</style>
